import typeToReducer from 'type-to-reducer';
import uuid from 'uuid/v4';
import { combineReducers } from 'redux';

import {
  ADD_INLINE_MESSAGE,
  ADD_SINGLE_INLINE_MESSAGE,
  REMOVE_INLINE_MESSAGE,
  CLEAR_INLINE_MESSAGES,
  ADD_GROWL_MESSAGE,
  REMOVE_GROWL_MESSAGE,
  CLEAR_GROWL_MESSAGES,
} from 'messages/constants';

const inlineMessageState = {};

const inlineMessageReducers = {
  [ADD_INLINE_MESSAGE]: (state, { payload: { type, text } }) => ({
    // ...state, // This is when you want to put one or more inline messages
    // whit the ...state, commented this function is identical to ADD_SINGLE_INLINE_MESSAGE
    [uuid()]: {
      type,
      text,
    },
  }),
  [ADD_SINGLE_INLINE_MESSAGE]: (state, { payload: { type, text } }) => ({
    // Similar to Add_inline_message, but only has one message at the time.
    [uuid()]: {
      type,
      text,
    },
  }),
  [REMOVE_INLINE_MESSAGE]: (state, { payload: { id } }) => {
    delete state[id];
    return { ...state };
  },
  [CLEAR_INLINE_MESSAGES]: (state, { payload: { type } }) =>
    type
      ? Object.keys(state)
          .filter((id) => state[id].type !== type)
          .map((id) => state[id])
      : {},
};

const growlMessageState = {};

const growlMessageReducers = {
  [ADD_GROWL_MESSAGE]: (state, { payload: { type, text, title } }) => ({
    [uuid()]: {
      type,
      text,
      title,
    },
  }),
  [REMOVE_GROWL_MESSAGE]: (state, { payload: { id } }) => ({
    ...Object.keys(state)
      .filter((key) => key !== id)
      .map((id) => state[id]),
  }),
  [CLEAR_GROWL_MESSAGES]: (state, { payload: { type } }) => ({}),
};

export default combineReducers({
  inline: typeToReducer(inlineMessageReducers, inlineMessageState),
  growl: typeToReducer(growlMessageReducers, growlMessageState),
});



// WEBPACK FOOTER //
// src/modules/messages/reducers/messages_reducers.js